export default __webpack_public_path__ + "static/media/instagramLogo.c6b91003.svg";